import React, { useEffect, useState } from 'react'
import { notification } from 'antd'
import { Button, PageHeader, Table } from 'src/components/Ant'
import { Tenant } from 'src/types'
import * as TenantService from 'src/services/api/tenant'
import history from 'src/config/routes/history'
import useDocumentTitle from 'src/hooks/use-document-title'
import * as CSS from './styles'

export default function ManageTenant() {
  useDocumentTitle('web.tenant.title')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [list, setList] = useState<Tenant[]>([])

  useEffect(() => {
    let isSubscribed = true
    setIsLoading(true)
    TenantService.getAll()
      .then(response => {
        if (!isSubscribed) {
          return
        }

        if (response.status === 200) {
          setList(response.data)
          return
        }
        notification.error({
          message: JSON.stringify(response.data),
          duration: 8
        })
      })
      .catch(response => {
        if (isSubscribed) {
          notification.error({
            message: JSON.stringify(response.data),
            duration: 8
          })
        }
      })
      .finally(() => {
        if (isSubscribed) {
          setIsLoading(false)
        }
      })
    return () => {
      isSubscribed = false
    }
  }, [])

  return (
    <>
      <PageHeader
        extra={[
          <Button
            key="common.actions.add"
            onClick={() => {
              history.push('/tenant/new')
            }}
            size="default"
            title="common.actions.add"
            type="primary"
          />
        ]}
        title="web.tenant.title"
      />
      <CSS.Content>
        <Table
          className="table-striped"
          columns={[
            {
              dataIndex: '',
              title: 'web.tenant.organization-name',
              render: record =>
                record?.tenant_identity ?? record?.tenant_name ?? ''
            },
            {
              dataIndex: 'tenant_type',
              title: 'web.user.common.user-type.title'
            }
          ]}
          dataSource={list}
          loading={isLoading}
          onRow={record => ({
            onClick: () =>
              history.push(`/tenant/${record.tenant_id}`, { record })
          })}
        />
      </CSS.Content>
    </>
  )
}
